<div class="mt-2">
    <h6 class="card-header-label" style="padding-left: 1em;">Pagatore</h6>
    <ng-container *ngFor="let payer of payersList">
        <div class="pt-2">
            <div class="d-flex align-items-center vertical-align-middle justify-content-between">
                <div class="p-1 col-8">
                    <app-policy-card (actionRequested)="modifyPayer(payer)" (deleteCardCallback)="deletePayer()" [showVisibilityIcon]="true" [showDeleteIcon]="true" [item]="payer" [title]="payer.nome +' '+ payer.cognome" [keys]="userKeys" [tooltip]="'Nuovo beneficiario'">
                    </app-policy-card>
                </div>
            </div>
        </div>
    </ng-container>
    <div *ngIf="!payersList || (payersList &&  payersList.length === 0)" class="mt-4 d-flex">
        <button mat-raised-button class="mx-3" color="primary" (click)="openNewBeneficiaryModal()">
            {{ 'aggiungi pagatore' | uppercase }}
        </button>
    </div>
</div>